var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiggestMovers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6210395F-06E1-42B4-A1B2-E2049B2740B2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "24.5273438 0 35.0273438 0 35.0273438 10.5 31.0078125 6.48046875 19.9335938 17.4726562 12.9609375 10.5 2.4609375 21 0 18.5390625 12.9609375 5.578125 19.9335938 12.5507812 28.546875 4.01953125"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-1109.000000, -479.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-3",
    transform: "translate(1109.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#999999",
    x: 7,
    y: 11,
    width: 156,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#999999",
    x: 7,
    y: 62,
    width: 119,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#999999",
    x: 7,
    y: 78,
    width: 102,
    height: 9
  }), /*#__PURE__*/React.createElement("text", {
    id: "+%",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#6BBE0B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 164.821546,
    y: 77
  }, "+%")), /*#__PURE__*/React.createElement("g", {
    id: "Tint",
    transform: "translate(188.736842, 59.263158)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#6BBE0B",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggestMovers);
export default __webpack_public_path__ + "static/media/biggest-movers.67955229f452eb4125ad611c3a0cefa0.svg";
export { ForwardRef as ReactComponent };